import { FC } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

import { FeatureFlags } from '@app/components';
import { FeatureFlagToMatch, ROUTE } from '@app/constants';

type ConditionalRouteProps = {
  flagsToMatch: FeatureFlagToMatch[];
  shouldRenderOnFalse?: boolean;
};

export const ConditionalRoute: FC<RouteProps & ConditionalRouteProps> = ({
  flagsToMatch,
  shouldRenderOnFalse = false,
  children,
}) => {
  const navigateToNotFound = () => <Navigate replace to={ROUTE.notFound} />;
  const renderChildren = () => children;

  const renderProps = {
    renderOn: shouldRenderOnFalse ? navigateToNotFound : renderChildren,
    renderOff: shouldRenderOnFalse ? renderChildren : navigateToNotFound,
  };

  return <FeatureFlags flagsToMatch={flagsToMatch} {...renderProps} />;
};
